<template>
  <div id="user-edit-tab-info">
    <div class="vx-col w-full">
      <div v-if="data_local.userdata.PaymentInfo == null">
        <table>
          <tr>
            <td class="font-semibold"> Payment information is empty </td>
          </tr>
        </table>
      </div>
      <!-- <vx-card v-else title="Payment Information" class="mb-base w-full"> -->
      <div v-else>
        <div v-if="data_local.userdata.PaymentInfo.type == 'Payoneer'">
          <div class="vx-row">
            <div class="vx-col md:w-1/2 w-full">
              <vs-input class="w-full mt-4" label="Payment Method" v-model="data_local.userdata.PaymentInfo.type"
                v-validate="'required'" name="firstname" disabled />
              <vs-input class="w-full mt-4" label="Currency" v-model="data_local.userdata.PaymentInfo.currency"
                v-validate="'required'" name="email" disabled />
            </div>
            <div class="vx-col md:w-1/2 w-full" style="margin-bottom:100px">
              <vs-input class="w-full mt-4" label="Payoneer Address" v-model="data_local.userdata.PaymentInfo.account"
                v-validate="'required'" name="userid" disabled />
            </div>
          </div>
        </div>
        <div v-if="data_local.userdata.PaymentInfo.type == 'SEFA'">
          <div class="vx-row">
            <div class="vx-col md:w-1/2 w-full">
              <vs-input class="w-full mt-4" label="Payment Method" v-model="data_local.userdata.PaymentInfo.type"
                v-validate="'required'" name="firstname" disabled />
              <vs-input class="w-full mt-4" label="Currency" v-model="data_local.userdata.PaymentInfo.currency"
                v-validate="'required'" name="email" disabled />
            </div>
            <div class="vx-col md:w-1/2 w-full" style="margin-bottom:100px">
              <vs-input class="w-full mt-4" label="IBAN" v-model="data_local.userdata.PaymentInfo.account"
                v-validate="'required'" name="userid" disabled />
              <vs-input class="w-full mt-4" label="Country of you bank" v-model="countrytext" v-validate="'required'"
                name="Birthday" disabled />
            </div>
          </div>
        </div>
        <div v-if="data_local.userdata.PaymentInfo.type == 'Tether'">
          <div class="vx-row">
            <div class="vx-col md:w-1/2 w-full">
              <vs-input class="w-full mt-4" label="Payment Method" v-model="data_local.userdata.PaymentInfo.type"
                v-validate="'required'" name="firstname" disabled />
              <vs-input class="w-full mt-4" label="Network" v-model="data_local.userdata.PaymentInfo.currency"
                v-validate="'required'" name="email" disabled />
            </div>
            <div class="vx-col md:w-1/2 w-full" style="margin-bottom:100px">
              <vs-input class="w-full mt-4" label="Crypto Wallet Address" v-model="data_local.userdata.PaymentInfo.account"
                v-validate="'required'" name="userid" disabled />
            </div>
          </div>
        </div>
      </div>
      <!-- </vx-card> -->
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";

export default {
  components: {
    vSelect,
  },
  props: {
    userData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      data: "",
      countrytext: "",
      phone: "",
      address: "",
      website: "",
      postcode: "",
      data_local: JSON.parse(JSON.stringify(this.userData)),

      departOptions: [
        { label: "1", value: "1" },
        { label: "2", value: "2" },
        { label: "3", value: "3" },
        { label: "4", value: "4" },
        { label: "5", value: "5" },
        { label: "6", value: "6" },
        { label: "7", value: "7" },
        { label: "8", value: "8" },
        { label: "9", value: "9" },
        { label: "10", value: "10" }
      ],
      roleOptions: [
        { label: "SuperAdmin", value: "superadmin" },
        { label: "president", value: "president" },
        { label: "Officer", value: "officer" },
        { label: "Researcher", value: "researcher" },
        { label: "Engineer", value: "engineer" },
      ],
      companyOptions: [
        { label: "7*9", value: "7*9" },
        { label: "3*9", value: "3*9" },
        { label: "5*4", value: "5*4" },
        { label: "8*2", value: "8*2" },
        { label: "AI", value: "ai" },
        { label: "Net", value: "net" },
      ],
      teamOptions: [
        { label: "1", value: "1" },
        { label: "2", value: "2" },
        { label: "3", value: "3" },
        { label: "4", value: "4" },
        { label: "5", value: "5" },
        { label: "6", value: "6" },
        { label: "7", value: "7" },
        { label: "8", value: "8" },
        { label: "9", value: "9" },
      ],
    };
  },
  computed: {
    status_local: {
      get() {
        const val = this.data_local.userdata.status === true ? "Approved" : "Pending";
        return { label: this.capitalize(val), value: val };
      },
      set(obj) {
        this.data_local.userdata.status = obj.value;
      },
    },
    role_local: {
      get() {
        return {
          label: this.capitalize(this.data_local.userdata.role),
          value: this.data_local.userdata.role,
        };
      },
      set(obj) {
        this.data_local.userdata.role = obj.value;
      },
    },
    validateForm() {
      return !this.errors.any();
    },
    chipColor (value) {
      return (value) => {
        if (value === 'Approved' ) return 'success'
        else if (value === 'Rejected') return 'danger'
        else return 'primary'
      }
    },
    status (value) {
      return (value) => {
        if (value === 'Approved') return 'Approved'
        else if(value === 'Rejected') return 'Rejected'
        else return 'Pending'
      }
    }

  },
  methods: {
    capitalize(str) {
      return str.slice(0, 1).toUpperCase() + str.slice(1, str.length);
    },
    save_changes() {
      /* eslint-disable */
      //      if (!this.validateForm) return;

      const payload = {
        userDetails: {
          _id: this.data_local.userdata._id,
          firstname: this.data_local.userdata.firstname,
          lastname: this.data_local.userdata.lastname,
          userId: this.data_local.userdata.id,
          role: this.data_local.userdata.role,
          birthday: this.data_local.userdata.birthday,
          email: this.data_local.userdata.email,
          country: this.data_local.userdata.country
        },
        file: this.data_local.userdata.avatar,
      };
      // sending file to the backendthis.$store
      this.$store
        .dispatch("userManagement/updateUser", payload)
        .then((res) => {
          this.reset_data();
        })
        .catch((err) => {
          this.$vs.notify({
            color: "danger",
            title: "User Upload Failed!",
            text: res.message,
          });
          console.error(err);
        });

      // Here will go your API call for updating data
      // You can get data in "this.data_local"

      /* eslint-enable */
    },
    reset_data() {
      this.data_local = JSON.parse(JSON.stringify(this.data));
    },
    update_avatar(e) {
      let files = e.target.files || e.dataTransfer.files;
      this.createImage(files[0]);
      // You can update avatar Here
      // For reference you can check dataList example
      // We haven't integrated it here, because data isn't saved in DB
    },
    createImage(file) {
      let reader = new FileReader();
      let vm = this;
      this.data_local.userdata.avatar = file;
      reader.onload = (e) => {
        document.getElementsByClassName("avatar_image")[0].src = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    removeAvatar() {
      this.data_local.userdata.avatar = ""
      document.getElementsByClassName(
        "avatar_image"
      )[0].src = require("@/assets/images/avatar.png");
    },
  },
  created() {
    this.name = this.data_local.userdata.firstname + ' ' + this.data_local.userdata.lastname
    this.countrytext = (this.data_local.userdata.PaymentInfo.country == 0) ? "The Netherlands" : (this.data_local.userdata.PaymentInfo.country == 1) ? "The United States" : (this.data_local.userdata.PaymentInfo.country == 2) ? "The Tailland" : "The Ukriane"
  }
};
</script>

<style>
.mychip{
  margin-top: 20px;
  width: 50%;
  height: 38px;
}
</style>